#import "../EditHistoryFields.graphql"

fragment HifoFields on HifoAdmin {
  id
  name
  status
  website
  primaryCauseArea
  worldview
  researcherRelationship {
    id
    name
  }
  evaluator {
    id
    name
  }
  approver {
    id
    name
  }
  reviewer {
    id
    name
  }
  lastEvaluated
  firstFullReviewDate
  dateStoppedBeingHifo
  expiryDate
  audience
  hifoType
  rating
  operatingAreas
  charity {
    id
    name
    salesforceId
  }
  parentCharity {
    id
    name
  }
  funds {
    id
    name
  }
  roomForFunding {
    currency
    minorUnit
  }
  approvalStatus
  minDonationAmount {
    currency
    minorUnit
  }
  grantRestrictions
  primaryContact
  primaryContactEmails
  evaluationTemplateLink
  isResearchInternal
  rejectedReason
  description
  imageUrl
  iconUrl
  includedInEstimatedImpact
  includedInGrantRecommendations
  charityCategoryIds
  impactData {
    id
    goal
    causeAreaInsights
    intervention
    majorAchievements
    achievements {
      id
      description
      icon
    }
    whyWeRecommend
    stories
    areQuantitativeFiguresAvailable
    hifo {
      id
      name
    }
    records {
      id
      recordType
      value
      valueType
      description
      static
      sortOrder
      lowerBounds
      upperBounds
      icon
      updates {
        id
        value
        lowerBounds
        upperBounds
        fromDate
      }
    }
  }
  createdAt
  editHistory {
    ...EditHistoryFields
  }
  createdBy {
    id
    name
  }
  updatedAt
  updatedBy {
    id
    name
  }
}
